
<template>
    <taskboard 
        :listable-id="$store.getters.getProfile.id"
        :listable-type="'user'"
    ></taskboard>
</template>

<script>
	import Taskboard from '@/components/common/Taskboard.vue'

    export default {
	    name: 'my-taskboard',
        components: {
            Taskboard
        },

        props: {

        },

        data() {
            return {}
        },
    }
</script>